import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { QuotationUnit } from 'data-layer-cr/dist/models';

export type PricingPackagesState = {
  packages: QuotationUnit[];
};

export const initialState: PricingPackagesState = {
  packages: [],
};

const pricingPackageSlice = createSlice({
  name: 'pricingPackages',
  initialState,
  reducers: {
    setPackages: (state, action: PayloadAction<QuotationUnit[]>): void => {
      state.packages = action.payload;
    },
  },
});

export const { setPackages } = pricingPackageSlice.actions;

export default pricingPackageSlice.reducer;
